import { render } from "./PayrollPayouts.vue?vue&type=template&id=53318fe2"
import script from "./PayrollPayouts.vue?vue&type=script&lang=js"
export * from "./PayrollPayouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__